import https from "@/cmmon/js/https";
import http from "./newhttps";

// 防抖
export const debounce = (func, wait = 3000, immediate = true) => {
    let timeout = null;
    return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
            if (callNow) func.apply(context, args);
        } else {
            timeout = setTimeout(function () {
                func.apply(context, args);
            }, wait);
        }
    };
};
// 时间戳方案
export const throttleTime = (fn, wait = 3000) => {
    var pre = Date.now();
    return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
            fn.apply(context, args);
            pre = Date.now();
        }
    };
};
// 定时器方案
export const throttleSetTimeout = (fn, wait = 3000) => {
    var timer = null;
    return function () {
        var context = this;
        var args = arguments;
        if (!timer) {
            timer = setTimeout(function () {
                fn.apply(context, args);
                timer = null;
            }, wait);
        }
    };
};
    // 通过 userAgent 判断是否在小程序 WebView 中
    export const isInMiniProgram=()=> {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('miniprogram') !== -1;
    }

// 打开小程序内链接
export const openLinkMini=(params={})=> {
    http.post('/external/app/wx/url_link', params).then(res=>{
       window.location.href = res.data.url;
    }).catch(err=>{

    })
}

/**
 * H5 跳转小程序原生页（自动带 token）
 * @param {string} path - 小程序页面路径，如 /pages/lottery/index
 * @param {object} query - 额外参数，如 { gameId: '123' }
 */
export const miniNavigateTo = (path, query = {}) => {
    if (!isInMiniProgram()) return
    var wx = require('weixin-js-sdk')

    var token = sessionStorage.getItem('tokentwo') || ''
    var refresh = sessionStorage.getItem('refresh') || ''

      var allQuery = Object.assign({ token: token, refresh: refresh }, query)
    var queryString = Object.keys(allQuery)
        .filter(function(k) { return allQuery[k] !== undefined && allQuery[k] !== null && allQuery[k] !== '' })
        .map(function(k) { return k + '=' + encodeURIComponent(allQuery[k]) })
        .join('&')
    var url = queryString ? path + '?' + queryString : path
    console.log(url,'rul');
    
    wx.miniProgram.navigateTo({ url: url })
}

/**
 * H5 跳转小程序原生页 — 接受完整 URL，自动补 token
 * 用法：miniNav('/pages/lottery/index?gameId=123')
 * @param {string} rawUrl - 完整的小程序页面路径（可带参数）
 */
export const miniNav = (rawUrl) => {
    var parts = rawUrl.split('?')
    var path = parts[0]
    var existingQuery = {}
    if (parts[1]) {
        parts[1].split('&').forEach(function(pair) {
            var seg = pair.split('=')
            existingQuery[seg[0]] = decodeURIComponent(seg[1] || '')
        })
    }
    miniNavigateTo(path, existingQuery)
}

/**
 * H5 reLaunch 小程序页面（自动带 token）
 * @param {string} rawUrl - 完整的小程序页面路径（可带参数）
 */
export const miniReLaunch = (rawUrl) => {
    if (!isInMiniProgram()) return
    var wx = require('weixin-js-sdk')
    var token = sessionStorage.getItem('tokentwo') || ''
    var refresh = sessionStorage.getItem('refresh') || ''
    
    var parts = rawUrl.split('?')
    var path = parts[0]
    var existingQuery = {}
    if (parts[1]) {
        parts[1].split('&').forEach(function(pair) {
            var seg = pair.split('=')
            existingQuery[seg[0]] = decodeURIComponent(seg[1] || '')
        })
    }
   var allQuery = Object.assign({ token: token, refresh: refresh }, existingQuery)
    var queryString = Object.keys(allQuery)
        .filter(function(k) { return allQuery[k] !== undefined && allQuery[k] !== null && allQuery[k] !== '' })
        .map(function(k) { return k + '=' + encodeURIComponent(allQuery[k]) })
        .join('&')
    var url = queryString ? path + '?' + queryString : path
    wx.miniProgram.reLaunch({ url: url })
}

export const getUserInfo=async ()=> {
   let userInfo= JSON.parse(sessionStorage.getItem("agentsMsg"));
    let obj={};
    if(JSON.stringify(userInfo)=="{}"||!userInfo){
        try {
            let res = await https.get("user/app/self?do=check");
            if (res.code == 0) {
              obj = res.data;
              if (obj.labels) {
                if (obj.labels.includes("limit")) {
                  sessionStorage.setItem("isshowturn", true);
                } else {
                  sessionStorage.setItem("isshowturn", false);
                }
              }
              sessionStorage.setItem("oid", obj._id);
              sessionStorage.setItem("contractbank", obj.contractbank);
              if (obj.ispublish === true) {
                sessionStorage.setItem("ispublish", obj.ispublish);
              }
              sessionStorage.setItem("level", obj.level);
              sessionStorage.setItem("avatar", obj.avatar);
              sessionStorage.setItem("agentsMsg", JSON.stringify(obj));
            }
          } catch (e) {
            console.log(e)
        }
    } else{
        obj=userInfo
    }
      return obj
}

export const isInCurrentMonth=(isoTimeStr, isUTC = false)=> {
  if (!isoTimeStr || typeof isoTimeStr !== 'string') return false;
  const cleanTimeStr = isoTimeStr.trim().replace(/[^0-9T:.Z-]/g, '');
  const targetDate = new Date(cleanTimeStr);
  if (isNaN(targetDate.getTime())) {
    console.log('无效的时间字符串：', isoTimeStr);
    return false;
  }
  const targetYear = isUTC ? targetDate.getUTCFullYear() : targetDate.getFullYear();
  const targetMonth = isUTC ? targetDate.getUTCMonth() : targetDate.getMonth();
  const now = new Date();
  const currentYear = isUTC ? now.getUTCFullYear() : now.getFullYear();
  const currentMonth = isUTC ? now.getUTCMonth() : now.getMonth();
  return targetYear === currentYear && targetMonth === currentMonth;
}

export default {
    debounce,
    throttleTime,
    throttleSetTimeout,
    getUserInfo,
    openLinkMini,
    isInMiniProgram,
    miniNavigateTo,
    miniNav,
    miniReLaunch,
}
